var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPaymentIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 56,
  height: 56,
  fill: "none"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 56,
  height: 56,
  fill: "#E621D3",
  fillOpacity: 0.05,
  rx: 28
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#898989",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M24 20v16M34 28s-3-1-3-4 3-4 3-4v16M21 20v3a3 3 0 0 0 3 3v0a3 3 0 0 0 3-3v-3"
})));
export default SvgPaymentIcon;